import iframeResizer from 'iframe-resizer/js/iframeResizer';
import { useEffect } from 'react';
import styled from 'styled-components';

const EventIframePopup = ({
  modalStyles,
  iframeRef,
  iframeSrc,
  isTriggerFullScreen,
  onReady,
  onMessage,
  onResized,
}) => {
  useEffect(() => {
    let resizer = null;
    if (iframeRef.current) {
      try {
        resizer = iframeResizer(
          {
            license: 'GPLv3',
            log: false,
            checkOrigin: false,
            waitForLoad: false,
            resizeFrom: 'child',
            autoResize: true,
            // Callbacks
            onReady: () => onReady(iframeRef.current.iFrameResizer),
            onMessage,
            onResized,
          },
          iframeRef.current
        );
      } catch (error) {
        console.error('Iframe-resizer xxxx initialization error:', error);
      }
    }

    return () => {
      if (resizer && iframeRef.current) {
        try {
          iframeRef.current.iFrameResizer?.close();
        } catch (error) {
          console.error('Iframe-resizer xxxx Cleanup error:', error);
        }
      }
    };
  }, []);

  return (
    <IframeCoreStyled
      ref={iframeRef}
      src={iframeSrc}
      frameBorder="0"
      scrolling="no"
      $styles={modalStyles}
      $isFullScreen={isTriggerFullScreen}
    />
  );
};

const IframeCoreStyled = styled.iframe`
  width: 100%;
  overflow-y: scroll !important;
  overflow-x: hidden !important;
  height: ${(props) => props.$isFullScreen && '100dvh!important'};
  max-height: ${(props) =>
    !props.$isFullScreen && (props.$styles?.maxHeight || '95dvh')};
  border-radius: ${(props) => props.$styles?.borderRadius}px;
`;

export default EventIframePopup;
